var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon icon-shape mb-4 rounded-circle",class:[_vm.type && `icon-shape-${_vm.type}` && `${_vm.type}Light`],style:({ background: _vm.colorLight })},[_c('i',{class:[_vm.name, _vm.type]})])
}
var staticRenderFns = []

export { render, staticRenderFns }